import React from 'react';
import { Check } from 'lucide-react';
import './styles/PlatformConfiguration.css';

interface StepperProps {
  currentStep: number;
}

const steps = [
  'Organization',
  'Holding Setup',
  'Organization Structure',
  'Branding',
  'Module Activation',
  'Group Dashboard Cfg',
  'Executive Dashboard Cfg',
  'Portal Activation',
  'Role Setup',
  'User Setup',
  'User Hierarchy',
  'Governance Submodules',
  'Dashboard Widgets',
  'Company Profile Setup',
  'Committee Management',
  'Workflow Setup',
  'Notifications Setup',
  'Review & Finish',
];

const WINDOW_SIZE = 7; // how many consecutive steps to show before skipping to the last

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  const totalSteps = steps.length;

  const windowEnd = Math.min(currentStep + WINDOW_SIZE - 1, totalSteps);
  const visibleStepNumbers: number[] = [];
  for (let i = currentStep; i <= windowEnd; i++) visibleStepNumbers.push(i);

  const hasGap = windowEnd < totalSteps;
  if (hasGap) visibleStepNumbers.push(totalSteps);

  return (
    <div className="platform-stepper-container">
      {visibleStepNumbers.map((stepNumber, idx) => {
        const step = steps[stepNumber - 1];
        const completed = stepNumber < currentStep;
        const current = stepNumber === currentStep;

        const isBeforeGap = hasGap && idx === visibleStepNumbers.length - 2;

        return (
          <React.Fragment key={stepNumber}>
            <div className="step-item">
              <div
                className={`step-circle
                  ${completed ? 'step-circle-completed' : ''}
                  ${current ? 'step-circle-active' : ''}
                `}
              >
                {completed ? (
                  <Check className="step-check-icon" />
                ) : (
                  <span className={`step-number ${current ? 'step-number-active' : ''}`}>{stepNumber}</span>
                )}
              </div>

              <p className={`step-label ${completed || current ? 'step-label-active' : ''}`}>{step}</p>
            </div>

            {idx !== visibleStepNumbers.length - 1 && (
              <div
                className={`step-line
                  ${completed ? 'step-line-active' : ''}
                  ${isBeforeGap ? 'step-line-dotted' : ''}
                `}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
